import { render, staticRenderFns } from "./Comparative.vue?vue&type=template&id=b1a28d74&scoped=true"
import script from "./Comparative.vue?vue&type=script&lang=js"
export * from "./Comparative.vue?vue&type=script&lang=js"
import style0 from "./Comparative.vue?vue&type=style&index=0&id=b1a28d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a28d74",
  null
  
)

export default component.exports